<template>
    <div>
        <div class="pt-[20px] pr-[0px] bg-[#ededed]">
            <div class="max-w-[1400px] w-full container mx-auto">
                <div class="pt-[60px] pr-[20px] pb-[2%] pl-[10px]">
                    <offerNavigation />
                </div>
            </div>
        </div>
        <div class="max-w-[1400px] w-full container mx-auto">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
            <div class="pt-[30px] pr-[20px] pb-[40px] pl-[10px] text-center">
                <div v-if="!loading" id="content">
                    <div v-if="contacts.length >= 0">
                        <OrganizationAndContactName
                            :contact="contacts[0]"
                            :contact-id="contactId"
                            :organization-name="organizationName"
                            :contact-name="contactName"
                        />
                        <hr />
                        <OffersSection
                            :offers="displayedOffers"
                            :contact-id="contactId"
                            :selectOfferMethod="selectOffer"
                            :deleteMethod="confirmDeleteSingleOffer"
                            :pdfMethod="downloadPdf"
                            :hasLink="hasLink"
                        />
                    </div>
                    <FullButton
                        :link="'/offers/createoffer/' + $route.params.id + '/0'"
                        @click="clearSelectedOfferStore"
                        :title="$t('offers.addOffer')"
                        width="100"
                        colour="red"
                    />
                </div>
                <div v-else>
                    <p>{{ $t('loading') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useRoute } from 'vue-router'
    import useContactStore from '@/utils/useContactStore'
    import useOfferStore from '@/utils/useOfferStore'
    import FullButton from '@/components/Buttons/FullButton.vue'
    import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import OrganizationAndContactName from '@/components/Offers/OrganizationAndContactName.vue'
    import OffersSection from '@/components/Offers/OffersSection.vue'
    import { computed } from 'vue'
    import { Offer } from '@/model/types'

    const route = useRoute()
    const { contacts, fetchContactsSearch } = useContactStore()
    const {
        offers,
        loading,
        selectOffer,
        confirmDeleteSingleOffer,
        downloadPdf,
        clearSelectedOfferStore,
        fetchOffers,
        hasLink,
    } = useOfferStore()
    const contactId = parseInt(route.params.id as string, 10)

    async function fetchDataOnMounted() {
        loading.value = true // Set loading to true before fetch
        await fetchContactsSearch({ limit: 1, offset: 0, filter: contactId.toString() })
        if (offers.value.length === 0) {
            await fetchOffers()
        }
        loading.value = false // Set loading to false after fetch
    }

    fetchDataOnMounted()

    // Computed properties
    const organizationName = computed(() => contacts.value[0]?.organisation?.name || '')
    const contactName = computed(
        () =>
            `${contacts.value[0]?.person?.firstName} ${contacts.value[0]?.person?.familyName}` || ''
    )
    const displayedOffers = computed(
        () => offers.value.find((o: Offer) => o.contactId == contactId)?.offers || []
    )

    // Breadcrumbs
    const breadcrumbs = computed(() => [
        { title: 'Offerten', disabled: false, href: '/offers' },
        { title: 'Schulansicht', disabled: true, href: '/offers/schoolview/' },
    ])
</script>
